import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL !== undefined 
    ? process.env.REACT_APP_BACKEND_URL 
    : (process.env.NODE_ENV === "production" ? "" : "http://127.0.0.1:8000");

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("tower_admin_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function setAdminToken(token) {
    if (token) localStorage.setItem("tower_admin_token", token);
    else localStorage.removeItem("tower_admin_token");
}

export function getAdminToken() {
    return localStorage.getItem("tower_admin_token");
}
